<template>
  <div class="bg-[#f9f4e9] min-h-[300px] flex items-center justify-center py-12 sm:py-16 lg:py-20">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 w-full">
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 lg:gap-16 items-center">
        <!-- 图片容器 -->
        <div class="order-2 lg:order-1">
          <div class="relative overflow-hidden rounded-xl lg:rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300">
            <img 
              :src="backgroundImg" 
              class="w-full h-[240px] sm:h-[280px] lg:h-[280px] object-cover transform hover:scale-105 transition-transform duration-500"
              alt="成为我们的合作伙伴"
            />
          </div>
        </div>

        <!-- 文本内容容器 -->
        <div class="order-1 lg:order-2 flex flex-col justify-center space-y-4 sm:space-y-6 text-center lg:text-left">
          <h2 class="text-2xl sm:text-3xl lg:text-3xl font-bold text-[#2f5c45] whitespace-pre-line mb-2 sm:mb-4 lg:mb-21">
            {{ t('becomeOurPartners.title') }}
          </h2>
          <p class="text-sm sm:text-base lg:text-2xs text-black leading-relaxed whitespace-pre-line px-2 sm:px-0">
            {{ t('becomeOurPartners.description') }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup name="becomeOurPartners">
  import { ref, onMounted, onUnmounted } from 'vue'
  import { useI18n } from 'vue-i18n'
  import backgroundImg from '../../../assets/other/hzhb.jpg'

  const { t } = useI18n()

  const formData = ref({
    fullName: '',
    phone: '',
    email: '',
    website: '',
    message: ''
  })
  const handleSubmit = () => {
    console.log('Form submitted:', formData.value)
  }
</script>

<style scoped>
 
</style>
